import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

const getTariffsTypes = async (isService) => {
  return await request.get(
    `/RentPlace/tariff`,
    {isService},
    'При загрузке типов счётчиков произошла ошибка',
    []
  );
};

const useTariffsTypes = (isService) =>
  useQuery([queries.tariffsTypes, isService], () => getTariffsTypes(isService), {
    placeholderData: [],
  });

export default useTariffsTypes;
